export const OUTLET_WRAPPER_ID = 'outlet-wrapper';
